module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-content"
  }, [_c('ul', {
    staticClass: "c-tabmenu c-tabmenu_max-200"
  }, [_c('li', {
    staticClass: "c-tabmenu__item"
  }, [_c('router-link', {
    staticClass: "c-tabmenu__link",
    attrs: {
      "to": {
        name: 'category',
        params: {
          category: 'cd'
        }
      }
    }
  }, [_c('span', {
    staticClass: "c-tabmenu__text"
  }, [_vm._v("CD")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "c-tabmenu__item"
  }, [_c('router-link', {
    staticClass: "c-tabmenu__link",
    attrs: {
      "to": {
        name: 'category',
        params: {
          category: 'bd'
        }
      }
    }
  }, [_c('span', {
    staticClass: "c-tabmenu__text"
  }, [_vm._v("Blu-ray&DVD")])])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "product-index"
    }
  }, [(!_vm.is_change_category) ? _c('div', {
    staticClass: "product-index"
  }, _vm._l((_vm.product_list), function(story, index) {
    return _c('div', {
      key: index,
      staticClass: "c-thumb-index product-index__index"
    }, _vm._l((story.items), function(item, index) {
      return _c('thumb-index-item', {
        key: index,
        attrs: {
          "item": item,
          "link": item.url,
          "append_class": _vm.append_class
        }
      })
    }))
  })) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98cf96ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/product/product-content.vue
// module id = 57
// module chunks = 0